export default __webpack_public_path__ + "static/40331-3510b7537098501272fdf406de6d18d7.jpg";